// User Endpoints Constants
export const USER_ENDPOINTS = {
  // User Search
  USER_SEARCH: "/user/search",

  // User Permission
  USER_PERMISSION: (userId: string) => `/user/${userId}/permission`,

  // User Me
  USER_ME: "/user/me",

  // User by id
  USER_BY_ID: (userId: string | number) => `/user/${userId}`,

  // Positions
  POSITIONS: "/position",
  POSITION_BY_ID: (positionId: string | number) => `/position/${positionId}`,
} as const;
